import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg, log } from 'utils';
import { saveAs } from 'file-saver';

export const SCREENS_FETCH_DATA_INIT = createAction('SCREENS_FETCH_DATA_INIT');
export const SCREENS_FETCH_DATA_SUCCESS = createAction(
  'SCREENS_FETCH_DATA_SUCCESS'
);
export const SCREENS_FETCH_DATA_FAIL = createAction('SCREENS_FETCH_DATA_FAIL');

export const SCREENS_DELETE_SCREEN_INIT = createAction(
  'SCREENS_DELETE_SCREEN_INIT'
);
export const SCREENS_DELETE_SCREEN_SUCCESS = createAction(
  'SCREENS_DELETE_SCREEN_SUCCESS'
);
export const SCREENS_DELETE_SCREEN_FAIL = createAction(
  'SCREENS_DELETE_SCREEN_FAIL'
);

export const SCREENS_CLEAR_DATA = createAction('SCREENS_CLEAR_DATA');

export const SCREENS_CREATE_SCREEN_INIT = createAction(
  'SCREENS_CREATE_SCREEN_INIT'
);
export const SCREENS_CREATE_SCREEN_SUCCESS = createAction(
  'SCREENS_CREATE_SCREEN_SUCCESS'
);
export const SCREENS_CREATE_SCREEN_FAIL = createAction(
  'SCREENS_CREATE_SCREEN_FAIL'
);

export const SCREENS_MODIFY_SCREEN_INIT = createAction(
  'SCREENS_MODIFY_SCREEN_INIT'
);
export const SCREENS_MODIFY_SCREEN_SUCCESS = createAction(
  'SCREENS_MODIFY_SCREEN_SUCCESS'
);
export const SCREENS_MODIFY_SCREEN_FAIL = createAction(
  'SCREENS_MODIFY_SCREEN_FAIL'
);

export const SCREENS_CLEAN_UP = createAction('SCREENS_CLEAN_UP');

export const SCREENS_CLEAR_DATA_LOGOUT = createAction(
  'SCREENS_CLEAR_DATA_LOGOUT'
);

export const SET_ACTIVE_TAB = createAction('SET_ACTIVE_TAB');
export const SET_ACTIVE_SCREEN = createAction('SET_ACTIVE_SCREEN');

export const SCREENS_DOWNLOAD_SCREEN_INIT = createAction(
  'SCREENS_DOWNLOAD_SCREEN_INIT'
);
export const SCREENS_DOWNLOAD_SCREEN_SUCCESS = createAction(
  'SCREENS_DOWNLOAD_SCREEN_SUCCESS'
);
export const SCREENS_DOWNLOAD_SCREEN_FAIL = createAction(
  'SCREENS_DOWNLOAD_SCREEN_FAIL'
);

export const fetchScreens = ({ screenId = '', siteId }) => {
  return async (dispatch, getState) => {
    dispatch(SCREENS_FETCH_DATA_INIT());
    if (screenId) {
      let screenData;
      try {
        const res = await axios.post(
          `${url}/screen/get`,
          {
            id: screenId,
            siteId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
        screenData = res.data.data;
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCREENS_FETCH_DATA_FAIL({ error }));
      }

      const screen = { ...screenData, id: screenId };
      log(screen);
      log(screenData);
      return dispatch(
        SCREENS_FETCH_DATA_SUCCESS({
          list: getState().screens.list,
          screen,
        })
      );
    }

    const { uid } = localStorage.getItem('uid');

    let screen;

    try {
      const res = await axios.get(`${url}/screen/`, {
        params: {
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      screen = res.data.data;
      log(screen);
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(SCREENS_FETCH_DATA_FAIL({ error }));
    }

    const screenData = screen
      ? Object.entries(screen).map(([key, value]) => ({
          id: key,
          ...value,
        }))
      : [];

    return dispatch(
      SCREENS_FETCH_DATA_SUCCESS({
        list: screenData.filter((screen) => screen.id !== uid),
        screen: getState().screens.screen,
      })
    );
  };
};

export const deleteScreen = ({ id, siteId }) => {
  return async (dispatch, getState) => {
    dispatch(SCREENS_DELETE_SCREEN_INIT());

    try {
      await axios.delete(`${url}/screen/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREENS_DELETE_SCREEN_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The screen was deleted.');
    return dispatch(SCREENS_DELETE_SCREEN_SUCCESS({ id }));
  };
};

export const createScreen = ({
  name,
  description,
  siteId,
  groupId,
  templateId,
  isLive,
  adsumScreenId,
  siteName,
  mediaCategoryId,
  width,
  height,
  modifiedAt,
  modifiedBy,
  allowMultipleConfig,
  screenConfigs,
  schedulingIds,
}) => {
  return async (dispatch, getState) => {
    dispatch(SCREENS_CREATE_SCREEN_INIT());

    const screen = {
      name,
      description,
      siteId,
      siteName,
      templateId,
      mediaCategoryId,
      isLive,
      width,
      height,
      groupId,
      modifiedAt,
      modifiedBy,
      allowMultipleConfig,
      screenConfigs,
      schedulingIds
    };

    if (adsumScreenId) {
      screen.adsumScreenId = adsumScreenId;
    }
    try {
      await axios.post(`${url}/screen/create`, screen, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREENS_CREATE_SCREEN_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'screen created successfully');
    return dispatch(SCREENS_CREATE_SCREEN_SUCCESS({ screen }));
  };
};

export const modifyScreen = ({
  name,
  description,
  siteId,
  siteName,
  mediaCategoryId,
  isLive,
  width,
  height,
  templateId,
  adsumScreenId,
  groupId,
  id,
  allowMultipleConfig,
  screenConfigs,
  schedulingIds
}) => {
  return async (dispatch) => {
    dispatch(SCREENS_MODIFY_SCREEN_INIT());

    const screenData = {
      name,
      description,
      siteId,
      templateId,
      groupId,
      mediaCategoryId,
      isLive,
      width,
      height,
      siteName,
      allowMultipleConfig,
      screenConfigs,
      schedulingIds
    };

    screenData.adsumScreenId = adsumScreenId || null;
    try {
      await axios.post(`${url}/screen/${id}`, screenData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREENS_MODIFY_SCREEN_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Screen updated successfully');

    return dispatch(SCREENS_MODIFY_SCREEN_SUCCESS({ screen: screenData, id }));
  };
};

export const screensCleanUp = () => (dispatch) => dispatch(SCREENS_CLEAN_UP());

// added by me
export const setActiveTab = (tab) => {
  return (dispatch) => {
    dispatch(SET_ACTIVE_TAB(tab));
  };
};

export const setActiveScreen = (screen, cb) => {
  return (dispatch) => {
    dispatch(SET_ACTIVE_SCREEN(screen));
    cb();
  };
};


const removeSpaceString = (name) =>{
  return name.replace(/\s+/g, '');
};

export const downloadScreenConfig = ({ screenId, siteName, screenName }) => {
  return async (dispatch) => {
    dispatch(SCREENS_DOWNLOAD_SCREEN_INIT());

    try {
      const response = await axios.get(`${url}/screen/${screenId}/download-config`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        responseType: 'blob', // Important for downloading
      });

      let filename = `${removeSpaceString(siteName)}_${removeSpaceString(screenName)}.json`;


      // Save file using Blob
      const blob = new Blob([response.data], { type: response.headers['content-type'] });

      // Option 1: Use file-saver (recommended for cross-browser)
      saveAs(blob, filename);

      // Option 2: Native download (no external lib)
      // const link = document.createElement('a');
      // link.href = URL.createObjectURL(blob);
      // link.setAttribute('download', filename);
      // document.body.appendChild(link);
      // link.click();
      // link.remove();

      toastr.success('', 'Screen config downloaded successfully');
      return dispatch(SCREENS_DOWNLOAD_SCREEN_SUCCESS());
    } catch (error) {
      log(error);
      let errorMessage = error?.response?.data?.message || 'Something went wrong';
      toastr.error('', errorMessage);
      return dispatch(
        SCREENS_DOWNLOAD_SCREEN_FAIL({
          error: error?.response?.data,
        })
      );
    }
  };
};


export const generateApiKey = ({
                                 screenId,
                                 siteId
                               }, cb) => {
  return async (dispatch) => {
    dispatch(SCREENS_MODIFY_SCREEN_INIT());

    try {
      await axios.post(`${url}/screen/${screenId}/generate-key`, { siteId }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREENS_MODIFY_SCREEN_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    if(cb)cb();
    toastr.success('', 'Api key generated successfully');
    return dispatch(SCREENS_MODIFY_SCREEN_SUCCESS( ));
  };
};

export const revokeApiKey = ({
                               screenId,
                               siteId
                             }, cb) => {
  return async (dispatch) => {
    dispatch(SCREENS_MODIFY_SCREEN_INIT());

    try {
      await axios.post(`${url}/screen/${screenId}/revoke-key`, { siteId }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREENS_MODIFY_SCREEN_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    if(cb)cb();

    toastr.success('', 'Api key revoked successfully');
    return dispatch(SCREENS_MODIFY_SCREEN_SUCCESS( ));
  };
};
